export const colorsTheme = {
  white: '#FFFFFF',
  black: '#000000',
  danger: '#F2383A',

  'gradient-deg': '90deg',
  'gradient-primary': '#D5B666',
  'gradient-secondary': '#051514',

  'primary-color': '#D5B666',
  'secondary-color': '#646464',
  'auxiliary-color': '#D5B666',

  'secondary-button-background': 'transparent',
  'secondary-button-background-hover': '#D5B666',
  'secondary-button-color': '#D5B666',
  'secondary-button-color-hover': '#FFFFFF',
  'secondary-button-border': '#D5B666',
  'secondary-button-border-hover': '#D5B666',

  'bg-color': '#FFFFFF',
  'bg-secondary-color': '#121212',
  'bg-auxiliary-color': '#EDEDED',

  'bg-circle-color': '#FFFFFF',
  'bg-modal-color': '#FFFFFF',

  'filter-button-background': '#D5B666',
  'filter-button-color': '#FFFFFF',
  'filter-button-border': '#D5B666',
  'entry-message-color': '#D5B666',

  'dark-color': '#3F3F3F',

  'text-primary': '#1E1E1E',
  'text-secondary': '#D5B666;',
  'text-tertiary': '#FFFFFF;',
  'text-gray': '#4F4F4F',
  
  'input-color': '#1E1E1E',
  'bg-input-color': '#FFFFFF',
  'info-color': '#B6E3D6',
  'disabled-color': '#e2e2e2',
  'card-color': '#EEEEEE',
  'modal-border-color': '#ADB5BD',
  'border-color': '#D5B666',
  'bg-login-color': '#D5B666',
  'bg-login-page-color': '#D5B666',

  'echeck-label-color': '#000',
  'echeck-border-color': '#D2D2D2',
  'echeck-text-color': '#000',
  'echeck-bar-color1': '#D5B666',
  'echeck-bar-color2': '#D5B666'
}